'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _controller = require('./controller');

var Controller = _interopRequireWildcard(_controller);

var _model = require('./model');

var Model = _interopRequireWildcard(_model);

var _view = require('./view.action');

var _view2 = _interopRequireDefault(_view);

var _view3 = require('./view.command');

var _view4 = _interopRequireDefault(_view3);

var _view5 = require('./view.logs');

var _view6 = _interopRequireDefault(_view5);

var _view7 = require('./view.snapshot');

var _view8 = _interopRequireDefault(_view7);

var _reduxShip = require('redux-ship');

var Ship = _interopRequireWildcard(_reduxShip);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Index = function (_PureComponent) {
  _inherits(Index, _PureComponent);

  function Index() {
    _classCallCheck(this, Index);

    return _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).apply(this, arguments));
  }

  _createClass(Index, [{
    key: 'render',
    value: function render() {
      var state = this.props.state;

      var selectedLog = Model.getSelectedLog(state);
      var selectedSnapshotItem = Model.getSelectedSnapshotItem(state);
      var selectedSnapshotItemIndex = Model.getSelectedSnapshotItemIndex(state);
      var style = {
        notification: {
          marginBottom: 25,
          padding: 10
        },
        tileChild: {
          overflowX: 'auto',
          padding: 15
        },
        tileParent: {
          padding: 3
        }
      };
      return _react2.default.createElement(
        'div',
        { className: 'container', style: { maxWidth: 'none' } },
        _react2.default.createElement(
          'div',
          { className: 'notification', style: style.notification },
          _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
              'div',
              { className: 'tile is-ancestor is-vertical' },
              _react2.default.createElement(
                'div',
                { className: 'tile' },
                _react2.default.createElement(
                  'div',
                  { className: 'tile is-parent is-3', style: style.tileParent },
                  _react2.default.createElement(
                    'div',
                    { className: 'tile is-child box', style: style.tileChild },
                    _react2.default.createElement(_view6.default, {
                      dispatch: this.props.dispatch,
                      state: state
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'tile is-vertical is-9' },
                  _react2.default.createElement(
                    'div',
                    { className: 'tile is-parent', style: style.tileParent },
                    _react2.default.createElement(
                      'div',
                      { className: 'tile is-child box', style: style.tileChild },
                      _react2.default.createElement(_view2.default, {
                        action: selectedLog && selectedLog.action
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'tile is-parent', style: style.tileParent },
                    _react2.default.createElement(
                      'div',
                      { className: 'tile is-child box', style: style.tileChild },
                      _react2.default.createElement(_view8.default, {
                        dispatch: this.props.dispatch,
                        serialized: !!selectedLog && selectedLog.serialized,
                        snapshot: selectedLog && selectedLog.snapshot,
                        selectedSnapshotItemIndex: selectedSnapshotItemIndex
                      })
                    )
                  ),
                  selectedSnapshotItem && _react2.default.createElement(
                    'div',
                    { className: 'tile is-parent', style: style.tileParent },
                    _react2.default.createElement(
                      'div',
                      { className: 'tile is-child box', style: style.tileChild },
                      _react2.default.createElement(_view4.default, {
                        snapshotItem: selectedSnapshotItem
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Index;
}(_react.PureComponent);

exports.default = Index;


/*****************
 ** WEBPACK FOOTER
 ** ./~/devtools/dist/main/view.js
 ** module id = 398
 ** module chunks = 0
 **/